module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Welcome to our creative store - we sell uncommon design\nillustrations that smack you right in the heart.")]), _c('section', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "gallery"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category
      }
    }, [_vm._v("Category: " + _vm._s(category))])
  })), _c('span', {
    staticClass: "select-arrow"
  })]), _c('div', {
    staticClass: "select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSort),
      expression: "selectedSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sorts), function(sort) {
    return _c('option', {
      domProps: {
        "value": sort
      }
    }, [_vm._v("Sort by: " + _vm._s(sort))])
  })), _c('span', {
    staticClass: "select-arrow"
  })])]), _c('transition-group', {
    staticClass: "gallery-row",
    attrs: {
      "name": "gallery-anim",
      "tag": "div",
      "mode": "out-in"
    }
  }, _vm._l((_vm.filteredProducts), function(product, index) {
    return (index >= _vm.productsOnPage * (_vm.activePage - 1) && index < _vm.productsOnPage * _vm.activePage) ? _c('div', {
      key: index,
      staticClass: "gallery-product"
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      },
      on: {
        "click": function($event) {
          _vm.showProductModal(product)
        }
      }
    }), _c('div', {
      staticClass: "product-actions",
      class: {
        "product-actions--active": _vm.starBoxHover
      }
    }, [_c('a', {
      staticClass: "cart-link",
      class: {
        "cart-link--active": _vm.checkInCart(product)
      },
      on: {
        "click": function($event) {
          _vm.addToCart(product)
        }
      }
    }), _c('div', {
      staticClass: "star-box",
      on: {
        "mouseenter": function($event) {
          _vm.starBoxHover = true
        },
        "mouseleave": function($event) {
          _vm.starBoxHover = false
        }
      }
    }, _vm._l((5), function(star) {
      return _c('span', {
        staticClass: "star star-link",
        on: {
          "click": function($event) {
            _vm.rateProduct(product, (6 - star))
          }
        }
      })
    }))])]), _c('h2', {
      staticClass: "product-title",
      on: {
        "click": function($event) {
          _vm.showProductModal(product)
        }
      }
    }, [_vm._v(_vm._s(product.name))]), _c('span', {
      staticClass: "product-author"
    }, [_vm._v(_vm._s(product.author))]), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$" + _vm._s(product.price) + ".00")])]) : _vm._e()
  }))], 1), _c('aside', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget-top"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Top Rated")]), _c('ul', {
    staticClass: "top-list"
  }, _vm._l((_vm.topProducts), function(product) {
    return _c('li', {
      staticClass: "top-product"
    }, [_c('div', {
      staticClass: "top-product-info"
    }, [_c('a', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(product.name))]), _c('div', {
      staticClass: "product-stars"
    }, _vm._l((5), function(n) {
      return _c('span', {
        staticClass: "star",
        class: {
          "star-full": n <= _vm.getStars(product)
        }
      })
    })), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$" + _vm._s(product.price) + ".00")])]), _c('div', {
      staticClass: "top-product-img"
    }, [_c('img', {
      staticClass: "product-img",
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })])])
  }))]), (_vm.cartShow) ? _c('div', {
    staticClass: "widget-cart"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Cart Review")]), _c('ul', {
    staticClass: "cart-list"
  }, _vm._l((_vm.productsInCart), function(product, key) {
    return _c('li', {
      staticClass: "cart-product"
    }, [_c('a', {
      staticClass: "product-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })]), _c('div', {
      staticClass: "product-description"
    }, [_c('a', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(product.name))]), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$ " + _vm._s(product.price))])]), _c('a', {
      staticClass: "product-remove",
      on: {
        "click": function($event) {
          _vm.removeFromCart(key)
        }
      }
    })])
  })), _c('div', {
    staticClass: "cart-subtotal"
  }, [_c('span', [_vm._v("Subtotal")]), _c('span', [_vm._v("$ " + _vm._s(_vm.cartAmount()))])]), _c('div', {
    staticClass: "cart-links"
  }, [_c('a', {
    staticClass: "cart-view",
    on: {
      "click": function($event) {
        _vm.changePage("Cart")
      }
    }
  }, [_vm._v("View Cart")]), _c('a', {
    staticClass: "cart-checkout",
    on: {
      "click": function($event) {
        _vm.changePage("Checkout")
      }
    }
  }, [_vm._v("Checkout")])])]) : _vm._e(), _vm._m(0)])]), _c('nav', {
    staticClass: "pagination"
  }, [_c('a', {
    staticClass: "nav-prev",
    class: {
      "nav-disable": _vm.activePage == 1
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.activePage - 1)
      }
    }
  }, [_vm._v("Prev Page")]), _c('div', {
    staticClass: "nav-pages"
  }, _vm._l((Math.ceil(_vm.filteredProducts.length / _vm.productsOnPage)), function(n) {
    return _c('a', {
      staticClass: "page-num",
      class: {
        "page-active": n == _vm.activePage
      },
      on: {
        "click": function($event) {
          _vm.changeGalleryPage(n)
        }
      }
    }, [_vm._v(_vm._s(n))])
  })), _c('a', {
    staticClass: "nav-next",
    class: {
      "nav-disable": _vm.activePage == Math.ceil(_vm.filteredProducts.length / _vm.productsOnPage)
    },
    on: {
      "click": function($event) {
        _vm.changeGalleryPage(_vm.activePage + 1)
      }
    }
  }, [_vm._v("Next Page")])]), (_vm.productModal) ? _c('product', _vm._b({
    on: {
      "close": _vm.closeProductModal
    }
  }, 'product', {
    productModal: _vm.productModal,
    topProducts: _vm.topProducts
  })) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-payment"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Payment Options")]), _c('p', {
    staticClass: "payment-details"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed\ndo eiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _c('div', {
    staticClass: "payment-option"
  }, [_c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/paypal.svg")
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/visa.svg")
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/mastercard.svg")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7e4acb1c"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Shop.vue
// module id = 132
// module chunks = 0